import { Label, Error, ClassHelper } from 'components/lib';
import Tooltip from '@mui/material/Tooltip';
// MUI v9 dropped the base `HelpOutline` alias; `HelpOutlineOutlined` is the
// same icon (identical glyph) under the canonical name.
import HelpOutlineIcon from '@mui/icons-material/HelpOutlineOutlined';
import Style from './select.tailwind.js';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  name: string;
  label?: string;
  labelTooltip?: string;
  options?: SelectOption[];
  default?: string;
  value?: string;
  className?: string;
  errorMessage?: string;
  required?: boolean;
  valid?: boolean;
  warning?: boolean;
  style?: React.CSSProperties;
  onChange: (name: string, value: string, valid: boolean) => void;
  callback?: (value: string) => void;
}

export function Select(props: SelectProps) {
  let options = props.options;
  const error = props.errorMessage || 'Please select an option';

  // set the default
  if (!props.default && options?.length) {
    // if theres no default, show a please select option
    if (options && options[0]?.value === 'unselected') options.shift();
    options.unshift({ value: 'unselected', label: 'Please select an option' });
  }

  function change(e: React.ChangeEvent<HTMLSelectElement>) {
    let value = e ? e.target?.value : 'unselected';
    let valid = undefined;

    // validate
    valid = props.required && value === 'unselected' ? false : true;
    props.onChange(props.name, value, valid);
    props.callback && props.callback(value);
  }

  const wrapperStyle = ClassHelper(Style, {
    className: props.className,
    success: props.valid === true,
    errorWrapper: props.valid === false,
    warningWrapper: props.warning,
  });

  const selectStyle = ClassHelper(Style, {
    select: true,
    error: props.valid === false,
    warning: props.warning,
  });

  return (
    <div
      className={Style.input}
      // it was added by Huseyin
      // style={{ width: props.width }}
    >
      <div className={Style.labelRow}>
        <Label text={props.label} required={props.required} for={props.name} className={Style.labelInline} />
        {props.labelTooltip && (
          <Tooltip title={props.labelTooltip} placement="top" arrow>
            <HelpOutlineIcon className="help-outline-icon" sx={{ marginTop: '-7px', marginLeft: '-4px' }} />
          </Tooltip>
        )}
      </div>

      <div className={wrapperStyle}>
        <select
          className={selectStyle}
          value={props.value ?? props.default ?? 'unselected'}
          style={props.style}
          onChange={(e) => change(e)}
          id={props.name}
        >
          {options?.map((option) => {
            return (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            );
          })}
        </select>

        {props.valid === false && <Error message={error} className={Style.message} />}
      </div>
    </div>
  );
}
